import { handleActions, combineActions } from 'redux-actions';
// import { get, post } from 'api/apiUtils';
import { APP_NAME } from 'config';
import clinicLocationData from 'data/locations'; // Mock data

/* ---------- API URLS  ---------- */
const APPOINTMENT_URLS = {
  GET_LOCATIONS: '/locations',
  HOLD_APPOINTMENT: '/appointment',
};

/* ---------- ACTIONS  ---------- */
const GET_LOCATIONS = `${APP_NAME}/appointment/GET_LOCATIONS`;
const GET_LOCATIONS_SUCCESS = `${APP_NAME}/appointment/GET_LOCATIONS_SUCCESS`;
const HOLD_APPOINTMENT = `${APP_NAME}/appointment/HOLD_APPOINTMENT`;
const HOLD_APPOINTMENT_SUCCESS = `${APP_NAME}/appointment/HOLD_APPOINTMENT_SUCCESS`;

/* ---------- ACTION CREATORS ---------- */
export function getLocations () {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_LOCATIONS, loading: true });
      // const locations = await get(APPOINTMENT_URLS.GET_LOCATIONS);
      const locations = clinicLocationData; // Mock data
      return dispatch({
        type: GET_LOCATIONS_SUCCESS,
        loading: false,
        locations: locations
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

export function holdAppointment (appointment) {
  return async (dispatch) => {
    try {
      dispatch({ type: HOLD_APPOINTMENT, loading: true });
      // await post(APPOINTMENT_URLS.HOLD_APPOINTMENT, {appointment});
      return dispatch({
        type: HOLD_APPOINTMENT_SUCCESS,
        loading: false,
        appointment: {}
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

/* ---------- REDUCER ---------- */
const initialState = {
  loading: false,
  locations: null,
};

const handlers = {
  [combineActions(GET_LOCATIONS, HOLD_APPOINTMENT)]: (state, action) => {
    return {
      ...state,
      loading: action.loading
    };
  },
  [GET_LOCATIONS_SUCCESS]: (state, action) => {
    return {
      ...state,
      loading: action.loading,
      locations: action.locations
    };
  },
  [HOLD_APPOINTMENT_SUCCESS]: (state, action) => {
    return {
      ...state,
      loading: action.loading,
      appointment: action.appointment
    };
  },
};

export default handleActions(handlers, initialState);



// WEBPACK FOOTER //
// ./src/redux-modules/modules/appointment.js